// extracted by mini-css-extract-plugin
export default {"cash-container":"Cash_cash-container__ZDSvI"};